export default __webpack_public_path__ + "static/media/android 2.55fb3839.png";